export default __webpack_public_path__ + "static/media/ADVIKA_pdf1.37209716.pdf";